var AnswersClients = /** @class */ (function () {
    function AnswersClients() {
    }
    AnswersClients.helpcenter = 'helpcenter';
    AnswersClients.app = 'app';
    return AnswersClients;
}());
export { AnswersClients };
var RemoteFileBuilder = /** @class */ (function () {
    function RemoteFileBuilder() {
        this.file = {
            name: 'bob',
            url: 'http://test.com',
            client: AnswersClients.helpcenter,
            lastUpdateDate: Date.now()
        };
    }
    RemoteFileBuilder.prototype.withName = function (name) {
        this.file.name = name;
        return this;
    };
    RemoteFileBuilder.prototype.withLastUpdateDate = function (date) {
        this.file.lastUpdateDate = date.getTime();
        return this;
    };
    RemoteFileBuilder.prototype.withClient = function (client) {
        this.file.client = client;
        return this;
    };
    RemoteFileBuilder.prototype.withUrl = function (url) {
        this.file.url = url;
        return this;
    };
    RemoteFileBuilder.prototype.build = function () {
        return this.file;
    };
    return RemoteFileBuilder;
}());
export { RemoteFileBuilder };
//# sourceMappingURL=remote-file-builder.js.map